export default __webpack_public_path__ + "static/media/MBA.43a16f29.jpg";